// Core
import QS from "qs";
import { AxiosRequestConfig } from "axios";
import { http } from "@/network/http-provider";

// Definitions
import { ProvidersFilterParamsType, ProvidersListType, ProviderType } from "./types";
import { HttpRequestParams } from "@/types/http";

// Utils
import { providersKeys } from "./apiKeys";

export const providersApi = Object.freeze({
  fetchProviders: (payload: HttpRequestParams<void, ProvidersFilterParamsType>) => {
    const { params } = payload;
    const config = {
      params,
      paramsSerializer: (p: AxiosRequestConfig): string =>
        QS.stringify(p, { encode: true, arrayFormat: "indices" }),
    };
    return http.get<ProvidersListType>(providersKeys.providers, config);
  },
  fetchOneProvider: (payload: { slug: string }) => {
    return http.get<ProviderType>(`${providersKeys.providers}/${String(payload.slug)}`);
  },
});
